import { isNil } from 'lodash-es';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

export type PicturizedImageProps = Omit<
  DetailedHTMLProps<HTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  'children'
> & {
  fetchPriority?: 'high' | 'low' | 'auto';
  picture: Picture | string | undefined | null;
  as?: 'picture' | 'image';
  alt?: string;
};

export default function PicturizedImage({ picture, as, alt, fetchPriority, ...props }: PicturizedImageProps) {
  if (isNil(picture)) {
    return null;
  }

  if (typeof picture === 'string' || as === 'image') {
    const src = typeof picture === 'string' ? picture : picture.img.src;

    return (
      <img
        fetchPriority={fetchPriority}
        src={src}
        alt={alt}
        {...props}
      />
    );
  }

  return (
    <picture>
      {Object.entries(picture.sources).map(([format, src]) => (
        <source
          key={format}
          srcSet={src}
          type={`image/${format}`}
        />
      ))}
      <img
        fetchPriority={fetchPriority}
        src={picture.img.src}
        alt={alt}
        {...props}
      />
    </picture>
  );
}
